<template>
    <div class="d-flex certificate-ug2 bg-white w-100" style="width: 1056px !important; height: 816px;">
        <div class="c-left">
            <div class="card pl-3 pr-2 my-3 pt-2">
                <div class="card-header d-flex container-header-images pt-2 pb-0 mr-3">
                    <img src="../assets/Logo_Erasmus.png" class="logo-erasmus">
                    <img src="../assets/Logo_PROF_XXI.png" class="logo-prof_xxi mr-3">
                </div>
                <div class="card-body mt-3 pt-4">
                    <h2 class="pl-4 pr-0 text-uppercase mb-0 text-dark-50 title-constancia campton-bold mt-2"><strong>CONSTANCIA</strong></h2>
                    <h6 class="pl-4 pr-0 text-uppercase color-ug mt-0 pb-0 campton-regular text-participation"><strong>de participación</strong></h6>
                    <p class="card-text pl-4 pr-0 pt-3 mb-0 campton-semibold letter-s1 font-weight-bold text-dark-50">El proyecto PROF-XXI otorga la presente constancia digital a:</p>
                    <div class="container-user-name pt-3">
                        <h4 class="pl-4 pr-0 mt-2 mb-1 title-name color-ug font-weight-bold">{{name}} {{lastname}}</h4>
                        <hr class="hr-name">
                    </div>
                    <div class="py-2 pl-4 pr-4 container-info-course">
                        <div class="borders-container">
                            <h6 class="text-dark-50">Por su participación en el curso:</h6>
                            <h6 class="letter-s2 mb-0 pb-0 pt-2"><strong>El profesor del siglo XXI: Aprende a enseñar</strong></h6>
                            <h6 class="letter-s2 my-0 py-0"><strong>con tecnologías digitales</strong></h6>
                            <p class="text-info-course pr-0 text-mini pb-0 mb-0 text-dark-50 pt-1">Este curso fue impartido en modalidad virtual, con una duración de 4 semanas y {{effort}} horas</p>
                            <p class="text-info-course pr-0 text-mini pb-0 mb-0 text-dark-50">aproximadas de esfuerzo del estudiante.</p>
                        </div>
                    </div>
                    <div class="firm d-flex justify-content-between pl-4 py-3">
                        <div class="col-4 px-0 text-center">
                            <img src="../assets/manager-dr-carlos-delgado.png" alt="" class="signature-img">
                            <hr />
                            <h5 class="nombre mb-1 nombre text-left color-ug pt-1 ml-2">Dr. Carlos Delgado Kloos</h5>
                            <h6 class="text-center mb-1 text-dark-75">Coordinador general</h6>
                            <h6 class="text-center mb-1 text-dark-75">Proyecto PROF-XXI</h6>
                        </div>
                        <div class="col-5 px-0 text-center">
                            <img src="../assets/manager_firma_rocael.png" alt="" class="signature-img-h">
                            <hr />
                            <h5 class="nombre text-left mb-1 color-ug pt-1">Dr. Rocael Hernández Rizzardini</h5>
                            <h6 class="text-center mb-1 text-dark-75">Coordinador técnico</h6>
                            <h6 class="text-cente0r mb-1 text-dark-75">Proyecto PROF-XXI</h6>
                        </div>
                    </div>
                    <div class="dp-footer pl-4 mb-0 pr-0">
                        <div class="row mb-0">
                            <div class="col-md-8">
                                <p class="text-l text-dark-50">Guatemala, {{signDate}}</p>
                                <div class="text-muted text-info-eacea pt-3">
                                    <p class="pb-0 mb-0">Curso financiado por la Unión Europea. Las opiniones y puntos de vista expresados solo comprometen a sus autores y no reflejan necesariamente los de la Unión</p>
                                    <p class="pb-0 mb-0">Europea o los de la Agencia Ejecutiva Europea de Eduación y Cultura (EACEA). Ni la Unión Europea ni la EACEA pueden ser considerados responsables de ellos.</p>
                                </div>
                            </div>
                            <div class="col-md-4 text-right">
                              <p class="text-l text-dark-50 mb-1 campton-bold" style="font-size:0.75rem; line-height: 1;"><strong>Valida aquí la autenticidad de este documento:</strong></p>
                              <QrcodeVueTemplate size="112" :url="verifyUrl"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="c-right">
            <img src="../assets/lateral.png" alt="">
        </div>
    </div>
</template>


<script>
import QrcodeVueTemplate from "../components/QrcodeVueTemplate.vue"
export default {
    name: "Profxxi",
    props: {
        name: String,
        lastname: String ,
        course: String,
        signDate: String ,
        verifyUrl: String ,
        effort: String
    },
    components: {
      QrcodeVueTemplate
    }
};
</script>


<style scoped>
@font-face {
  font-family: "CamptonBold";
  src: local("CamptonBold"),
   url(../assets/fonts/CamptonBold.otf) format("truetype");
}
@font-face {
  font-family: "CamptonBook";
  src: local("CamptonBook"),
   url(../assets/fonts/CamptonBook.otf) format("truetype");
}
@font-face {
  font-family: "CamptonMedium";
  src: local("CamptonMedium"),
   url(../assets/fonts/CamptonMedium.otf) format("truetype");
}
@font-face {
  font-family: "CamptonSemiBold";
  src: local("CamptonSemiBold"),
   url(../assets/fonts/CamptonSemiBold.otf) format("truetype");
}
.signature-img {
    width: 25.5%;
}
.signature-img-h {
    width: 100%;
}
.giz-logo{
    width: 300px;
    padding-top: 2.5em;
}
.certificate-ug2 > p {
    margin-bottom: 0;
}
.certificate-ug2 > p,h2,h3,h4,h5,h6 {
    font-family: 'CamptonSemiBold', sans-serif;
}
.color-ug {
    color: #af7c2b;
}
.shadow-card {
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
}
.card, .card .card-header {
    border-radius: 0;
    border-bottom: 0;
}
.border-ug {
    border: 1px solid #b89a59;
    z-index: 10;
}
.border-ug {
    margin: 10px;
    position: relative;
}
.firm h6, .firm h5 {
    font-size: 16.3px;
    font-family: 'CamptonBook', sans-serif;
}
.firm h5 {
    font-family: 'CamptonBold', sans-serif;
    font-weight: bold;
    letter-spacing: 2px;
    font-size: 1.1em;
}
.firm hr {
    margin-top: .3rem;
    margin-bottom: .3rem;
}
.certificate-ug {
    position: relative;
    margin: 10px;
}
.card {
    width: 100%;
    border: 0;
    z-index: 12;
    background-color: transparent;
}
.card .card-header {
    background: transparent;
}
.item-left, .item-right {
    position: absolute;
    top: 0;
    bottom: 0;
}
.item-left {
    width: 90%;
    background-color: #fff;
    z-index: 9;
    left: 0;
}
.item-right {
    width: 10%;
    background-color: #212529;
    z-index: 9;
    right: 0;
}
.certificate-left {
    width: 90%;
    height: 20px;
    background-color: #fff;;
}
.certificate-right {
    width: 10%;
    height: 20px;
    background-color: #212529;
}
.c-left {
    width: 86%;
}

.c-right img{
    height: 100%;
    width: 100%;
}
.c-right {
    width: 14%;
    /*background-color: #946400;*/
}
.certificate-ug2 {
    position: relative;
}
.text-mini {
    font-size: 0.79em;
}
.campton-bold {
    font-family: 'CamptonBold', sans-serif  !important;
    font-weight: bold;
}
.campton-regular {
    font-family: 'CamptonBook', sans-serif;
    font-weight: 400;
}
.campton-medium {
    font-family: 'CamptonMedium', sans-serif;
    font-weight: 500;
}
.campton-semibold {
    font-family: 'CamptonSemiBold', sans-serif;
    font-weight: 400;
}
.title-name {
    font-size: calc(14px + (36 - 14) * ((1000px - 500px) / (1600 - 500)));
}
.certificate-ug2 {
    background-image: url('../assets/background-dp.png');
    background-image: url('../assets/g12.png');
    background-repeat: no-repeat;
}
.letter-s1 {
    letter-spacing: 2px;
    font-size: 17px;
}
.letter-s2 {

}
.text-participation strong {
    letter-spacing: 6px;
    font-size: 1.08em;
}
.font-bold {
    font-weight: bold;
}
.text-b {
    font-size: 24px;
}
.text-m {
    font-size: 16px;
}
.text-l {
    font-size: 13.8px;
}
.letter-s2 strong{
    font-size: 1.57em;
}
.text-dark-50{
    /*color: rgb(53 53 53);*/
    color: #353535;
}
.text-dark-75 {
    color: #313839;
}
hr {
    border-top: 1px solid rgb(33 41 42 / 57%);
}
.container-header-images{
    direction: rtl;
}
.logo-erasmus {
    width: 150px;
    height: 33px;
    margin-top: 8px;
}
.logo-prof_xxi{
    width: 59px;
    height: 45px;
}

.hr-name {
    margin-left: 1.5em;
    margin-bottom: 0.5em;
}

.container-user-name {
    width: 75%;
}

.container-user-name .hr-name {
    margin-top: 2px;
}

.title-constancia strong{
    font-size: 1.35em;
}

.container-info-course {
    width: max-content;
}

.container-info-course .borders-container {
    background-image: linear-gradient(#af7c2b, #af7c2b), linear-gradient(#af7c2b, #af7c2b), linear-gradient(#af7c2b, #af7c2b), linear-gradient(#af7c2b, #af7c2b), linear-gradient(#4682b400, #4682b400);
    background-repeat: no-repeat;
    background-size: 10px 35px, 35px 10px, 10px 35px, 35px 10px, 99% 99%;
    background-position: left top, left top, right bottom, right bottom, 4px 4px;
    padding: 20px 34px 2px 20px;
}

.text-muted {
    color: #686969 !important
}

.text-info-eacea {
    font-size: 7.7396pt;
    font-family: 'CamptonBook', sans-serif;
}

.dp-footer p{
  font-family: 'CamptonBook', sans-serif;
}

.text-info-course {
    font-family: 'CamptonBook', sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/templates/Profxxi.vue